import { render, staticRenderFns } from "./BasketSetComponentList.vue?vue&type=template&id=8eecb10e&"
import script from "./BasketSetComponentList.vue?vue&type=script&lang=js&"
export * from "./BasketSetComponentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eecb10e')) {
      api.createRecord('8eecb10e', component.options)
    } else {
      api.reload('8eecb10e', component.options)
    }
    module.hot.accept("./BasketSetComponentList.vue?vue&type=template&id=8eecb10e&", function () {
      api.rerender('8eecb10e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/list/BasketSetComponentList.vue"
export default component.exports